import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AuthService } from './../../services/auth.service';
import Validation from './../providers/CustomValidators';

@Component({
    selector: 'app-update-user-password',
    templateUrl: './update-user-password.component.html',
    styleUrls: ['./update-user-password.component.scss'],
    standalone: false
})
export class UpdateUserPasswordComponent implements OnInit {
  submitted = false;
  success = '';
  updateUserPasswordForm: UntypedFormGroup;
  passwordStrength: any;
  showPasswordInfo = false;

  constructor(
    private dialog: MatDialogRef<UpdateUserPasswordComponent>,
    private auth$: AuthService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { mode?: 'change' | 'expiry' }
  ) {}

  get mode(): 'change' | 'expiry' {
    return this.data?.mode || 'expiry';
  }

  checkError(formControl, controlName: string, errorName?: string) {
    if (errorName) {
      return formControl.controls[controlName].hasError(errorName);
    }
    return;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.updateUserPasswordForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.updateUserPasswordForm.invalid) {
      return;
    }
    const { currentPasswordFormControl, newPasswordFormControl } = this.updateUserPasswordForm.value;
    this.dialog.close({ oldPassword: currentPasswordFormControl, newPassword: newPasswordFormControl });
  }

  onCancel(): void {
    this.dialog.close();
  }

  ngOnInit() {
    this.updateUserPasswordForm = new UntypedFormGroup(
      {
        currentPasswordFormControl: new UntypedFormControl('', [Validators.required]),
        confirmPasswordFormControl: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
        newPasswordFormControl: new UntypedFormControl('', [
          Validators.required,
          Validators.minLength(6),
          () => Validation.passwordStrength(this.passwordStrength),
        ]),
      },
      Validation.match('newPasswordFormControl', 'confirmPasswordFormControl'),
    );
  }

  onStrengthChanged(event) {
    this.passwordStrength = event;
    this.updateUserPasswordForm.controls['newPasswordFormControl'].updateValueAndValidity();
  }

  handleLogOut() {
    this.auth$.logout();
  }
}
